<template>

  <div id="titlepage">
<PageHeader></PageHeader>
    <div class="app__content-wrapper">
      <h1 class="white">{{ $t('settings_gettitle') }}</h1>

      <input v-model="title" placeholder="" class="title-input">
      <div id="titlepage__image">
        <img src="../assets/static/fig_gruppe.png">
      </div>

      <br><br>
      <router-link to="settings" class="button-big">{{ $t('global_next') }}</router-link>
    </div>

  </div>
</template>

<script>

// optional style for arrows & dots

import PageHeader from './PageHeader'
export default {
  name: 'Titlepage',
  components: { PageHeader },
  data: () => {
    return {
      showDelayed: false,
      settings: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true
      }
    }
  },
  created () {
    setTimeout(() => {
      window.track('Titlepage')
      this.showDelayed = true
    }, 1000)
  },
  methods: {
    showNext () {
      this.$refs.carousel.next()
    },
    selectGrid (gridId) {
      this.$store.dispatch('updateGrid', gridId)
    }
  },
  computed: {
    title: {
      get () {
        return this.$store.state.title
      },
      set (value) {
        this.$store.dispatch('updateTitle', value)
      }
    }
  }

}
</script>

<style lang="scss">
  .slideElement{
    height: 200px;
  }
</style>
<style lang="scss">

  #titlepage{
    margin: 0;
    padding: 0;
    width:100%;
    h2{
      font-family: 'Bangers', 'Alegreya Sans', cursive;
    }
  }
  #titlepage__image{
    max-width: 450px;
    margin: 0 auto;
    img{
      width:100%;
      height:auto;
    }
  }
  .title-input{
    outline: none;
    font-size:22px;
    box-sizing: border-box;
    border: 1px solid white;
    letter-spacing: 2px;
    padding: 4px;
    color: white;
    background-color:rgba(0, 0, 0, 0);
    font-family: 'Bangers', 'Alegreya Sans', cursive;
    text-align: center;
    width:90%;
    max-width: 500px;
    padding: 0.5em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
</style>
